import MuiTooltip, { TooltipProps as Props } from '@material-ui/core/Tooltip'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import * as React from 'react'

export type StyledTooltip = {
  label: string
}

export type TooltipProps = Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    colorTooltips: {
      background: theme.palette.common.black,
      padding: '14px 16px 10px 16px',
      fontSize: '14px',
      lineHeight: '24px'
    },
    arrow: {
      fontSize: 16,
      textAlign: 'center',
      '&::before': {
        backgroundColor: theme.palette.common.black
      }
    }
  })
)

const Tooltip: React.FC<TooltipProps> = (props) => {
  const classes = useStyles()
  const { children, ...rest } = props
  return (
    <MuiTooltip
      {...rest}
      classes={{ tooltip: classes.colorTooltips, arrow: classes.arrow }}
      arrow
    >
      {children}
    </MuiTooltip>
  )
}

export default Tooltip
